import React from 'react';
import { INLINE_1, INLINE_2 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';
import { Card } from 'Components/frameworks/card/Card';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
const LEFT = 'left';
type Props = CMSCard & {
  config: CMSContent;
  dataTestIdPrefix?: string;
  hasFullScreenMode?: boolean;
  id?: string;
  mediaPosition: 'left' | 'right';
};
export const MediaTextHorizontalLine = ({
  dataTestIdPrefix,
  id,
  mediaPosition,
  hasFullScreenMode,
  ...rest
}: Props) => (
  <SiteContainer className="Line" id={id}>
    {rest.mediaUrl ? (
      <Card
        {...mapColToCard(rest)}
        dataTestIdPrefix={dataTestIdPrefix}
        hasFullScreenMode={hasFullScreenMode}
        layout={mediaPosition === LEFT ? INLINE_1 : INLINE_2}
      />
    ) : (
      <Card
        {...mapColToCard(rest)}
        dataTestIdPrefix={dataTestIdPrefix}
        hasFullScreenMode={hasFullScreenMode}
        layout={INLINE_1}
      />
    )}
  </SiteContainer>
);
